import { Component, OnInit, Inject, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {DominiosService, UsuarioService } from '../shared/services/acordo-ressarcimento/api/services';

import { AppComponent } from '../app.component';
import { CategoriaDevedor } from '../shared/services/acordo-ressarcimento/api/models';
import { Observable, of } from 'rxjs';
import { LoadingService } from '../shared/services/components/loading.service';

@Component({
  selector: 'app-dominio-categoria-devedor',
  templateUrl: './dominio-categoria-devedor.component.html',
  styleUrls: ['./dominio-categoria-devedor.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class DominioCategoriaDevedorComponent implements OnInit {
  
  private _submittedNovoDevedor = false;
  public formCategoriaDevedor: FormGroup;
  public categoriasDevedor: CategoriaDevedor[];
  public categoriaDevedor: CategoriaDevedor;
  public loadingLista = false;
  public edicaoCategoriaDevedor = false;
  public indexEdicaoCategoriaDevedor = undefined;  

  source = [];
  columnsTemplate = [];
  
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public dominiosService: DominiosService,
  
    private route: ActivatedRoute,

    public usuarioService: UsuarioService,
    private loading: LoadingService,
    @Inject(AppComponent) public appComponent: AppComponent) {

    
  }

  public ngOnInit() {
    this.obterListaCategoriaDevedor();
    this.inicializarDadosCategoriaDevedor();
    this.criarFormulario(this.categoriaDevedor);
     
   
  }

  private obterListaCategoriaDevedor() {

    this.dominiosService.obterAllListaCategoriaDevedorResponse(  ).subscribe(result => {
      this.categoriasDevedor = result.body;
      console.log(JSON.stringify(result.body));
    });

  }
  public openEditarCategoriaDevedor(indexDeveddor) {
    this.limparDadosCategoriaDevedor();
    this.edicaoCategoriaDevedor = true;
    this.indexEdicaoCategoriaDevedor = indexDeveddor;
                
    this.formCategoriaDevedor.controls['nomeCategoriaDevedor'].setValue(this.categoriasDevedor[indexDeveddor].nomeCategoriaDevedor);
    if (this.categoriasDevedor[indexDeveddor].flagRegistroAtivo == 'S')
    this.formCategoriaDevedor.controls['flagRegistroAtivo'].setValue(true)
    else
    this.formCategoriaDevedor.controls['flagRegistroAtivo'].setValue(false)
    //this.formCategoriaDevedor.controls['flagRegistroAtivo'].setValue(this.categoriasDevedor[indexDeveddor].flagRegistroAtivo);
    this.formCategoriaDevedor.controls['codigoCategoriaDevedor'].setValue(this.categoriasDevedor[indexDeveddor].codigoCategoriaDevedor);
  }

  private limparDadosCategoriaDevedor() {

    this.formCategoriaDevedor.controls['codigoCategoriaDevedor'].setValue(null);
    this.formCategoriaDevedor.controls['nomeCategoriaDevedor'].setValue(null);
    this.formCategoriaDevedor.controls['flagRegistroAtivo'].setValue('S');    
  }

  private inicializarDadosCategoriaDevedor(): void {
    
    this.categoriaDevedor = {};
    this.categoriaDevedor.codigoCategoriaDevedor = 0;
    this.categoriaDevedor.nomeCategoriaDevedor = "";
    this.categoriaDevedor.flagRegistroAtivo = "S";    
  }

  private criarFormulario(categoriaDevedor: CategoriaDevedor) {
    this.formCategoriaDevedor = this.formBuilder.group({
      codigoCategoriaDevedor: null,//categoriaDevedor.codigoCategoriaDevedor,
      nomeCategoriaDevedor: "",
      flagRegistroAtivo: "S",
      
    });
  }

  public abrirModalCategoriaDevedor (evento) {
    
    console.log("Abrindo modal de categoria devedor");
  }

  onFecharModalCategoriaDevedor() {
    console.log("Fechando Modal");

  }

  public getSubmittedDevedor() {
    return this._submittedNovoDevedor;
  }

  

  public salvarCategoriaDevedor(modalGravando, modalCategoriaDevedor) {
    if (!this.validarFormulario()) {
      return
    }
    modalCategoriaDevedor.close();
    this.categoriaDevedor.codigoCategoriaDevedor = this.formCategoriaDevedor.value['codigoCategoriaDevedor'];
    this.categoriaDevedor.nomeCategoriaDevedor = this.formCategoriaDevedor.value['nomeCategoriaDevedor'];
    this.categoriaDevedor.flagRegistroAtivo = this.formCategoriaDevedor.value['flagRegistroAtivo'];
    console.log(this.categoriaDevedor.flagRegistroAtivo);
    if (this.categoriaDevedor.flagRegistroAtivo.toString() == 'false')
    this.categoriaDevedor.flagRegistroAtivo = 'N'
    if (this.categoriaDevedor.flagRegistroAtivo.toString() == 'true')
    this.categoriaDevedor.flagRegistroAtivo = 'S'

    this.loading.open();

    if (this.edicaoCategoriaDevedor) {
      console.log(JSON.stringify(this.categoriaDevedor));
      /*
      this.dominiosService.atualizarCategoriaDevedor(this.categoriaDevedor).subscribe(result => {
        this.appComponent.createAlert("Dados alterados com sucesso", 'success');
        this.loading.close();
        this.loadingLista = false;
        this.obterListaCategoriaDevedor();
      }, error => {
        this.appComponent.createAlert('Não foi possível salvar a categoria de Devedor', 'error');
        this.loading.close();
        this.loadingLista = false;
      });
      */
    } else {

    this.dominiosService.salvarCategoriaDevedor(this.categoriaDevedor).subscribe(result => {
      this.appComponent.createAlert("Dados salvos com sucesso", 'success');
      this.loading.close();
      this.loadingLista = false;
      this.obterListaCategoriaDevedor();
    }, error => {
      this.appComponent.createAlert('Não foi possível salvar a Categoria de Devedor', 'error');
      this.loading.close();
      this.loadingLista = false;
    });
    
  }
}
private validarFormulario(): boolean {
  let isCampoFocus = false;
  var isValido = true;

  if ((this.formCategoriaDevedor.get('nomeCategoriaDevedor').value == 0) || (this.formCategoriaDevedor.get('nomeCategoriaDevedor').value == undefined) || (this.formCategoriaDevedor.get('nomeCategoriaDevedor').value == null)|| (this.formCategoriaDevedor.get('nomeCategoriaDevedor').value == "")) {
    
      isValido = false;
      this.formCategoriaDevedor.controls['nomeCategoriaDevedor'].setErrors({ 'incorrect': true }); 
      this.appComponent.createAlert('Informe o nome da categoria devedor', 'error');       
  }
  
  
  return isValido;
}
}
